<template>
	<div class="appListView">
		<div class="alv_top">
			<div class="alv_top_left">
				<el-select
					v-model="selectJuri"
					:placeholder="lang.select_display_range"
					@change="changeSelect"
					style="width: 120px; margin-right: 10px"
				>
					<el-option
						v-for="item in selectJuriList"
						:key="item.index"
						:label="item.label"
						:value="item.index"
					></el-option>
				</el-select>

				<el-select
					v-model="selectType"
					@change="changeSelect"
					style="width: 110px; margin-right: 10px"
				>
					<el-option
						v-for="item in selectTypeList"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select>

				<el-select
					v-model="selectModel"
					:placeholder="lang.selectionMode"
					@change="changeSelect"
					style="width: 110px; margin-right: 10px"
				>
					<el-option
						v-for="item in selectModelList"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select>

				<el-select
					v-model="selectStatus"
					:placeholder="lang.please_select"
					@change="changeSelect"
					style="width: 130px; margin-right: 10px"
				>
					<el-option
						v-for="item in statusList"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select>

				<!-- <el-select
					v-model="selectTag"
					@change="changeSelect"
					style="width: 110px; margin-right: 10px"
				>
					<el-option
						v-for="item in selectTagList"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select> -->

				<!-- <el-select
					v-model="selectTag"
					@change="changeSelect"
					style="width: 110px; margin-right: 10px"
				>
					<el-option
						v-for="item in selectTagList"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select> -->


			</div>
			<div class="alv_top_right">
				<el-input class="alv_top_r_input" v-model="searchValue" @keyup.enter.native="getData">
					<i
						slot="suffix"
						style="font-size: 20px; cursor: pointer"
						@click="getData"
						class="el-input__icon el-icon-search"
					></i>
				</el-input>
				<div class="addAppBtn" @click="addApp">
					<span>+</span><span>{{ lang.Add_Application }}</span>
				</div>
			</div>
		</div>
		<div class="alv_bottom">
			<div class="alv_b_table">
				<div class="alb_b_t_header">
					<div class="alb_b_t_h_item">
						<span>{{ lang.app_name }}</span>
						<span>{{ lang.final_running_time }}</span>
						<span>{{ lang.cumulative_number_of_conversations }}</span>
						<span>{{ lang.the_number_of_teachers }}</span>
						<span>{{ lang.select_status }}</span>
						<span>{{ lang.operate }}</span>
					</div>
				</div>
				<div class="alv_b_t_box" v-loading="getDataLoading">
					<div class="alv_b_t_b_item" v-for="item in tableData" :key="item.id">
						<div>
							<div @click.stop="openAppDetail(item.id)">
								<img v-if="item.appJson && item.appJson.icon" :src="item.appJson.icon">
								<img v-else src="@/assets/img/ai_agent_header.png" />
								<span>{{ item.name }}</span>
							</div>
							<div @click.stop="openAppDetail(item.id)">{{ item.lastChat?item.lastChat:'-' }}</div>
							<div @click.stop="openAppDetail(item.id)">
								<span>{{ item.countChat?item.countChat:'-' }}</span>
							</div>
							<div @click.stop="openAppDetail(item.id)">
								<span>{{ item.teacher + 1 }}</span>
								<div class="collaboration">{{ lang.Collaboration }}</div>
							</div>
							<div @click.stop="openAppDetail(item.id)">
								<div :class="`status_${item.status} status`">
									{{ statusList.find(i=>i.value==item.status).label }}
								</div>
							</div>
							<div class="operationBtn">
								<el-popover
									placement="bottom-end"
									trigger="click"
									popper-class="teachingModePopover "
								>
									<div class="teachingModePopoverArea">
										<div class="teachingModePopoverAreaBtn" @click.stop="pauseApp(item.id)" v-if="item.status=='0'">{{ lang.pause }}</div>
										<div class="teachingModePopoverAreaBtn" @click.stop="startApp(item.id)" v-if="item.status=='1'">{{ lang.continue }}</div>
										<div class="teachingModePopoverAreaBtn" @click.stop="stopApp(item.id)" v-if="['0','1'].includes(item.status)">{{ lang.end }}</div>
										<div class="teachingModePopoverAreaBtn" @click.stop="delData(item.id)">{{ lang.clearData }}</div>
										<div class="teachingModePopoverAreaBtn" @click.stop="deleteApp(item.id)">{{ lang.deleteApp }}</div>
										<div class="teachingModePopoverAreaBtn" @click.stop="modifyClass(item.id)">{{ lang.modifyTheClass }}</div>
										<div class="teachingModePopoverAreaBtn" @click.stop="addTeacher(item.id)">{{ lang.addCollaborativeTeacher }}</div>
										<div class="teachingModePopoverAreaBtn" @click.stop="openAppAnalysis(item.id)">{{ lang.view_the_analysis }}</div>
										
									</div>
									<svg
										t="1732786015570"
										slot="reference"
										class="icon"
										viewBox="0 0 1024 1024"
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										p-id="9199"
										width="200"
										fill="rgba(150, 155, 163, 1)"
										height="200"
									>
										<path
											d="M192 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM512 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-29.866667-68.266667-68.266667-68.266667zM832 443.733333c-38.4 0-68.266667 29.866667-68.266667 68.266667 0 38.4 29.866667 68.266667 68.266667 68.266667s68.266667-29.866667 68.266667-68.266667c0-38.4-34.133333-68.266667-68.266667-68.266667z"
											p-id="9200"
										></path>
									</svg>
								</el-popover>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<applicationAnalysisDialog ref="applicationAnalysisDialogRef"/>
		<addAppDialog ref="addAppDialogRef" @success="addAppSuccess"/>
		<addClassDialog ref="addClassDialogRef" @success="changeClassSuccess"/>
		<addTeacherDialog ref="addTeacherDialogRef" @success="changeTeacherSuccess"/>
	</div>
</template>

<script>
import applicationAnalysisDialog from '../dialog/applicationAnalysisDialog.vue';
import addAppDialog from '../dialog/addAppDialog.vue';
import addClassDialog from '../dialog/addClassDialog.vue';
import addTeacherDialog from '../dialog/addTeacherDialog.vue';
export default {
	components:{
		applicationAnalysisDialog,
		addAppDialog,
		addClassDialog,
		addTeacherDialog
	},
	data() {
		return {
			selectJuriList: [
				{index:"",label:this.lang.AllApps},
				{ index: "0", label: this.lang.CollaborativeApps },
				{ index: "1", label: this.lang.MyApps },
			],
			selectTypeList: [
				{ value: "", label: this.lang.allTypes },
				{ value: "agent", label: this.lang.intelligent_agents },
				{ value: "workflow", label: this.lang.workflow },
			],
			selectModelList: [
				{ value: "", label: this.lang.allMode },
				{ value: "0", label: this.lang.chatMode },
				{ value: "1", label: this.lang.File_generation },
				{ value: "2", label: this.lang.immersion },
			],
			selectTagList: [
				{ value: "", label: this.lang.allTag, show: [1, 4] },
				{ value: "1", label: this.lang.authority, show: [1, 4] },
				{ value: "2", label: this.lang.winnow, show: [1, 4] },
				{ value: "3", label: this.lang.exclusive, show: [1, 4] },
				{ value: "4", label: this.lang.organization, show: [1, 4] },
				{ value: "5", label: this.lang.personal, show: [1] },
			],
			statusList: [
				{value:"",label:this.lang.AllStatuses},
				{value:"0",label:this.lang.active},
				{value:"1",label:this.lang.Paused},
				{value:"2",label:this.lang.Ended},
			],
			selectJuri: "",
			selectType: "",
			selectModel: "",
			selectTag: "",
			searchValue: "",
			selectStatus:"",
			tableData: [],
			getDataLoading:false,
			paramsJson:null,
			tempId:null,
			yMessage:null,
		};
	},
	methods: {
		changeSelect() {
			this.getData();
		},
		getData() {
			this.getDataLoading = true;
			let params = {
				uid:this.user.userId,
				jur:this.selectJuri,
				type:this.selectType,
				model:this.selectModel,
				status:this.selectStatus,
				search:this.searchValue
			}
			this.paramsJson = JSON.stringify(params);
			this.ajax.get(this.$store.state.api+'select_teachingMode',params).then(res=>{
				if(this.paramsJson!=JSON.stringify(params))return;
				let _data = res.data[0];
				if(_data.length>0){
					_data.forEach(i=>{
						i.appJson = i.appJson?JSON.parse(i.appJson):"";
						i.tJson = i.tJson && i.tJson !='undefined' ?JSON.parse(i.tJson):"";
						i.analysis = i.analysis?JSON.parse(i.analysis):"";
						i.teacher = i.collaborative_teacher?i.collaborative_teacher.split(",").filter(i=>i!="").length:0;
						// i.teacher = i.teacher+1;
					})

					this.tableData = _data;	
				}else{
					this.tableData = [];
				}
				console.log(res)
				this.getDataLoading = false;
			}).catch(err=>{
				console.log(err)
				this.getDataLoading = false;
			})
		},
		openAppDetail(id){
			console.log(id)
			this.$parent.changeDetailId(id);
			this.$parent.changeShowTag(1);
		},
		//暂停app
		pauseApp(id){
			let _index = this.tableData.findIndex(i=>i.id===id);
			if(!['0'].includes(this.tableData[_index].status))return;
			this.loading = true;
			let params = [
				{
					uid:this.user.userId,
					tid:this.tableData[_index].id,
					appId:this.tableData[_index].appId,
					name:this.tableData[_index].name,
					summary:this.tableData[_index].summary,
					collaborative_teacher:this.tableData[_index].collaborative_teacher,
					class_id:this.tableData[_index].class_id,
					status:'1',
					analysis:JSON.stringify(this.tableData[_index].analysis),
					json:JSON.stringify(this.tableData[_index].tJson),
				}
			]

			this.ajax.post(this.$store.state.api+"update_teachingMode",params).then(res=>{
				if(res.data==1){
					this.$message.success(this.lang.modifiedSuccessfully);
					// this.$emit("sendMessage",{type:"changeAppData",id:this.tableData[_index].id})
				}else{
					this.$message.success(this.lang.modificationFailure);
				}
				this.loading = false;
				this.getData();
			}).catch(err=>{
				console.log(err)
				this.loading = false;
				this.$message.success(this.lang.modificationFailure);
				this.getData();
			})
		},
		//开启app
		startApp(id){
			
			let _index = this.tableData.findIndex(i=>i.id===id);
			console.log(this.tableData[_index])
			if(!['1'].includes(this.tableData[_index].status))return;
			this.loading = true;
			let params = [
				{
					uid:this.user.userId,
					tid:this.tableData[_index].id,
					appId:this.tableData[_index].appId,
					name:this.tableData[_index].name,
					summary:this.tableData[_index].summary,
					collaborative_teacher:this.tableData[_index].collaborative_teacher,
					class_id:this.tableData[_index].class_id,
					status:'0',
					analysis:JSON.stringify(this.tableData[_index].analysis),
					json:JSON.stringify(this.tableData[_index].tJson),
				}
			]

			this.ajax.post(this.$store.state.api+"update_teachingMode",params).then(res=>{
				if(res.data==1){
					this.$message.success(this.lang.modifiedSuccessfully);
					// this.$emit("sendMessage",{type:"changeAppData",id:this.tableData[_index].id})
				}else{
					this.$message.success(this.lang.modificationFailure);
				}
				this.loading = false;
				this.getData();
			}).catch(err=>{
				console.log(err)
				this.loading = false;
				this.$message.success(this.lang.modificationFailure);
				this.getData();
			})
		},
		//停止app
		stopApp(id){
			this.$confirm(this.lang.confirmEndApp, this.lang.tip, {
				confirmButtonText: this.lang.queding,
				cancelButtonText: this.lang.cancel,
				type: "warning",	
			}).then(() => {
				let _index = this.tableData.findIndex(i=>i.id===id);
			if(!['0','1'].includes(this.tableData[_index].status))return;
			this.loading = true;
			let params = [
				{
					uid:this.user.userId,
					tid:this.tableData[_index].id,
					appId:this.tableData[_index].appId,
					name:this.tableData[_index].name,
					summary:this.tableData[_index].summary,
					collaborative_teacher:this.tableData[_index].collaborative_teacher,
					class_id:this.tableData[_index].class_id,
					status:'2',
					analysis:JSON.stringify(this.tableData[_index].analysis),
					json:JSON.stringify(this.tableData[_index].tJson),
				}
			]

			this.ajax.post(this.$store.state.api+"update_teachingMode",params).then(res=>{
				if(res.data==1){
					this.$message.success(this.lang.modifiedSuccessfully);
					// this.$emit("sendMessage",{type:"changeAppData",id:this.tableData[_index].id})
				}else{
					this.$message.success(this.lang.modificationFailure);
				}
				this.loading = false;
				this.getData();
			}).catch(err=>{
				console.log(err)
				this.loading = false;
				this.$message.success(this.lang.modificationFailure);
				this.getData();
			})	
			}).catch(() => {
				
			})
		},
		//删除数据
		delData(id){
			this.$confirm(this.lang.confirmClearData, this.lang.alertTit, {
				confirmButtonText: this.lang.queding,
				cancelButtonText: this.lang.cancel,
				type: "warning",	
			}).then(() => {
				let params = [{
					uid:this.user.userId,
					tid:id
				}]

				this.ajax.post(this.$store.state.api+"clear_teachingMode",params).then(res=>{
					// if(res.data>=1){
						console.log(res)
						this.$message.success(this.lang.clearDataSuccess)
					// }else{
					// 	this.$message.error(this.lang.deleteAppDataFail)
					// }
					this.getData();
				}).catch(err=>{
					console.log(err);
					this.$message.error(this.lang.clearDataFail)
				})
			}).catch(()=>{

			})
		},
		//删除应用
		deleteApp(id){
			this.$confirm(this.lang.confirmDeleteApp, this.lang.alertTit, {
				confirmButtonText: this.lang.queding,
				cancelButtonText: this.lang.cancel,
				type: "warning",	
			}).then(() => {
				let params = [{
					uid:this.user.userId,
					tid:id,
					isDel:1
				}]

				this.ajax.post(this.$store.state.api+"update_teachingModeIsDelete",params).then(res=>{
					if(res.data>=1){
						console.log(res)
						this.$message.success(this.lang.deleteAppSuccess)
					}else{
						this.$message.error(this.lang.deleteAppFail)
					}
					this.getData();
				}).catch(err=>{
					console.log(err);
					this.$message.error(this.lang.deleteAppFail)
				})
			}).catch(()=>{

			})
		},
		//打开应用分析
		openAppAnalysis(id){
      let _data = this.tableData.find(i=>i.id==id);
      console.log(_data)
			this.$refs.applicationAnalysisDialogRef.open(_data);
			// this.$message.info("打开应用分析")
		},
		addApp(){
			this.$refs.addAppDialogRef.open()
		},
		addAppSuccess(){
			this.$refs.addAppDialogRef.close();
			this.getData();
		},
		//修改班级
		modifyClass(id){
			this.tempId = id;
			let _data = this.tableData.find(i=>i.id==id).class_id.split(',');
			this.$refs.addClassDialogRef.open(_data);
		},	
		changeClassSuccess(data){
			let str = data.join(",");
			let _index = this.tableData.findIndex(i=>i.id==this.tempId);

			this.$refs.addClassDialogRef.loading = true;
      
			let params = [
				{
					uid:this.user.userId,
					tid:this.tableData[_index].id,
					appId:this.tableData[_index].appId,
					name:this.tableData[_index].name,
					summary:this.tableData[_index].summary,
					collaborative_teacher:this.tableData[_index].collaborative_teacher,
					class_id:str,
					status:this.tableData[_index].status,
					analysis:JSON.stringify(this.tableData[_index].analysis),
					json:JSON.stringify(this.tableData[_index].tJson),
				}
			]

			this.ajax.post(this.$store.state.api+"update_teachingMode",params).then(res=>{
				if(res.data==1){
					this.$message.success(this.lang.modifiedSuccessfully);
					// this.$emit("sendMessage",{type:"changeAppData",id:this.tableData[_index].id})
					this.$refs.addClassDialogRef.close();
				}else{
					this.$message.success(this.lang.modificationFailure);
				}
				this.$refs.addClassDialogRef.loading = false;
				this.getData();
			}).catch(err=>{
				console.log(err)
				this.$message.success(this.lang.modificationFailure);
				this.$refs.addClassDialogRef.loading = false;
				this.getData();
			})
			this.tempId = null;
		},
		//添加协作教师
		addTeacher(id){
			this.tempId = id;
			let _data = this.tableData.find(i=>i.id==id).collaborative_teacher.split(',');
			this.$refs.addTeacherDialogRef.open(_data);
		},
		changeTeacherSuccess(data){
			let str = data.join(",");
			let _index = this.tableData.findIndex(i=>i.id==this.tempId);

			let params = [
				{
					uid:this.user.userId,
					tid:this.tableData[_index].id,
					appId:this.tableData[_index].appId,
					name:this.tableData[_index].name,
					summary:this.tableData[_index].summary,
					collaborative_teacher:str,
					class_id:this.tableData[_index].class_id,
					status:this.tableData[_index].status,
					analysis:JSON.stringify(this.tableData[_index].analysis),
					json:JSON.stringify(this.tableData[_index].tJson),
				}
			]

			this.ajax.post(this.$store.state.api+"update_teachingMode",params).then(res=>{
				if(res.data==1){
					this.$message.success(this.lang.modifiedSuccessfully);
					this.$refs.addTeacherDialogRef.close();
					// this.$emit("sendMessage",{type:"changeAppData",id:this.tableData[_index].id})
				}else{
					this.$message.success(this.lang.modificationFailure);
				}
				this.$refs.addTeacherDialogRef.loading = false;
				this.getData();
			}).catch(err=>{
				console.log(err)
				this.$message.success(this.lang.modificationFailure);
				this.$refs.addTeacherDialogRef.loading = false;
				this.getData();
			})
			this.tempId = null;
		},
		//消息初始化
		// messageInit(){
		// 	if(this.doc){
		// 		this.yMessage = this.doc.getArray('message');
		// 		this.yMessage.observe(e=>{
		// 			e.changes.added.forEach(i=>{
		// 				const message = i.content.getContent()[0];
		// 				this.getMessages(message)
		// 			})
		// 		})
		// 	}
		// },
		// sendMessage(obj){
		// 	if(this.doc){
		// 		const {type,id} = obj;
		// 		const message = {
		// 			type:type,
		// 			id:id,
		// 			timestamp: new Date().toISOString()
		// 		}
		// 		this.doc.transact(()=>{
		// 		this.yMessage.push([message])
		// 		})
		// 	}
		// },
		// getMessages(msgObj){
		// 	let type = msgObj.type;
		// 	if(['changeAppData'].includes(type)){//更新指定app
		// 		let id = msgObj.id;
		// 		if(this.tableData.map(i=>i.id).includes(id)){
		// 			this.getDataByIdAndUpdate(id)
		// 		}
		// 	}
		// },
		getDataByIdAndUpdate(tid){
			if(!this.tableData.some(i=>i.id===tid))return;//不更新
			let params = {
				uid:this.user.userId,
				tid:tid
			}
			this.ajax.get(this.$store.state.api+"select_teachingModeById",params).then(res=>{
				let _result = res.data[0];
				if(_result.length>0){
					let _data = _result[0];
					_data.appJson = _data.appJson?JSON.parse(_data.appJson):"";
					_data.tJson = _data.tJson?JSON.parse(_data.tJson):"";
					_data.analysis = _data.analysis?JSON.parse(_data.analysis):"";
					_data.teacher = _data.collaborative_teacher?_data.collaborative_teacher.split(",").filter(i=>i!='').length:0;

					let _updateIndex = this.tableData.findIndex(i=>i.id===_data.id);
					if(_updateIndex!=-1){
						this.tableData[_updateIndex] = _data;
						this.$forceUpdate();
					}
				}
			}).catch(err=>{
				console.log('updateDataErr',err)
			})
		},
		
	},
	mounted() {
		this.getData();
	},
};
</script>

<style lang="scss" scoped>
.appListView {
	width: 100%;
	height: calc(100vh - 50px);
	min-height: 500px;
	.alv_top {
		width: 100%;
		height: 100px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		.alv_top_left {
			width: auto;
			height: auto;
			display: flex;
			align-items: center;
			margin: 10px 0;
		}
		.alv_top_right {
			width: auto;
			height: auto;
			display: flex;
			align-items: center;
			margin: 10px 0;
			.alv_top_r_input {
				width: 300px;
				::v-deep .el-input__inner {
					border-radius: 40px;
				}
			}
			.addAppBtn {
				width: auto;
				padding: 5px 20px;
				border-radius: 20px;
				white-space: nowrap;
				color: #fff;
				display: flex;
				align-items: center;
				background-color: #000;
				margin-left: 20px;
				cursor: pointer;
				transition: 0.3s;
				span {
					&:nth-child(1) {
						font-size: 18px;
						margin-right: 5px;
					}
					&:nth-child(2) {
						font-size: 14px;
					}
				}
			}
		}
	}
	.alv_bottom {
		width: 100%;
		height: calc(100% - 100px);
		.alv_b_table {
			width: 100%;
			height: calc(100% - 40px);
			box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
			border-radius: 12px;
			.alb_b_t_header {
				width: 100%;
				height: 48px;
				border-radius: 12px 12px 0 0;
				background-color: #fff;
				box-sizing: border-box;
				border-bottom: solid 1px #bdbdbd;
				padding: 0 50px;
				.alb_b_t_h_item {
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					span {
						display: flex;
						flex: 1;
						height: 100%;
						justify-content: center;
						align-items: center;
						font-size: 14px;
						color: #00000099;
						text-align: center;
						font-weight:bold;
						&:nth-child(1) {
							justify-content: flex-start;
							// color: #000;
						}
						&:nth-last-of-type(1) {
							justify-content: flex-end;
							flex: 0.5;
						}
					}
				}
			}
			.alv_b_t_box {
				width: 100%;
        height: fit-content;
				min-height: calc(100% - 48px);
        
				background-color: #fcfbfb;
				border-radius: 0 0 12px 12px;
				box-sizing: border-box;
				overflow: auto;
				box-sizing: border-box;
				// padding: 0 30px;
				.alv_b_t_b_item {
					width: 100%;
					height: 50px;
					display: flex;
					align-items: center;
					border-bottom: solid 1px #e7e7e7;
					transition: 0.2s;
					cursor: pointer;
					box-sizing: border-box;
					padding: 0 30px;
					&:hover {
						background-color: #fff;
						// border-color: #eaeaea;
					}
					& > div {
						width: 100%;
						position: relative;
						height: 50px;
						box-sizing: border-box;
						display: flex;
						align-items: center;
						justify-content: space-between;
						border-radius: 10px;
						// border: 1px solid #fcfbfb;
						padding: 0 20px;
						

						& > div {
							display: flex;
							flex: 1;
							height: 100%;
							justify-content: center;
							align-items: center;
							font-size: 14px;
							color: #606266;
							&:nth-child(1) {
								justify-content: flex-start;
								img {
									width: 30px;
									height: 30px;
									border-radius: 100%;
									margin-right: 8px;
									object-fit: cover;
								}
							}
							&:nth-last-of-type(1) {
								justify-content: flex-end;
								flex: 0.5;
								svg {
									width: 25px;
									height: 25px;
									cursor: pointer;
									transition: 0.3s;
									&:hover {
										fill: #3681fc !important;
									}
								}
							}
							.collaboration {
								padding: 2px 10px;
								background-color: none;
								margin-left: 10px;
								border: dashed 1px #000;
								border-radius: 20px;
								font-size: 14px;
								cursor: default;
							}
							.status {
								padding: 5px 15px;
								border-radius: 10px 0;
								font-size: 14px;
							}
							.status_0 {
								//background-color: #ddfceb;
								//color: #14c265;
								background-color: #effcf5;
								color: #17c469;
							}
							.status_1 {
								// background-color: #fae0cd;
								// color: #ee672d;
								background-color: #fff3ea;
								color: #e67f36;
							}
							.status_2 {
								background-color: #F3F3F3;
								color: #00000066;
							}
						}
					}
				}
			}
		}
	}
}



.teachingModePopoverArea{
	display: flex;
	flex-direction: column;
	align-items: center;
	width: fit-content;
	width: fit-content;
	height: auto;
}

.teachingModePopoverAreaBtn{
	display: flex;
	justify-content: center;
	align-items: center;
	width: calc(100% - 40px);
	padding: 1px 20px;
	height: 30px;
	font-size: 16px;
	border-radius: 8px;
	transition: .1s;
	margin: 5px 0;
}

.teachingModePopoverAreaBtn:hover{
	background-color: #f2f4f7;
	// color: #fff;
	cursor: pointer;
}
</style>
